import CouponApi from '@apis/coupon/CouponApi';
import queries from '@apis/queries';
import {
    GetDownloadableCouponsParams,
} from '@models/coupon';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getIsBlank, getNextPageParam } from '@utils/slice';
import { useState } from 'react';

function useDownloadAbleCoupons() {
    const [sorter, setSorter] = useState<GetDownloadableCouponsParams['sorter']>('CreatedAtAsc');
    const params: Omit<GetDownloadableCouponsParams, 'page'> = {
        size: 20,
        sorter,
    };
    const queryInfo = useInfiniteQuery({
        queryKey: queries.coupons.downloadAble(params).queryKey,
        queryFn: ({ pageParam }) => CouponApi.getDownloadableCoupons({
            ...params, page: pageParam,
        }),
        initialPageParam: 0,
        getNextPageParam,
    });
    const coupons = getFlattenPageResponse(queryInfo);
    const isBlank = getIsBlank(queryInfo);
    return {
        ...queryInfo,
        isBlank,
        coupons,
        sorter,
        setSorter,
    };
}

export default useDownloadAbleCoupons;
